<ng-container *transloco="let t; prefix: 'trip-finances.panels.fundraiser'">
  <app-panel-body>
    <form class="flex min-h-0 flex-1 flex-col" [formGroup]="form" (ngSubmit)="save()">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label class="mb-1 block text-sm font-medium" for="fundraiser-date">{{ t('date') }}</label>
                <input id="fundraiser-date" type="date" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="date" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="fundraiser-location">{{ t('location') }}</label>
                <input id="fundraiser-location" type="text" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="location" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="fundraiser-goal">{{ t('goal') }}</label>
                <input id="fundraiser-goal" type="number" min="0" step="0.01" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="goal" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="fundraiser-raised">{{ t('raised') }}</label>
                <input id="fundraiser-raised" type="number" min="0" step="0.01" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="raised" />
              </div>
            </div>

            <div>
              <label class="mb-1 block text-sm font-medium" for="fundraiser-description">{{ t('description') }}</label>
              <textarea id="fundraiser-description" rows="4" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="description"></textarea>
            </div>

            <app-participant-assignment-editor
              [totalAmount]="raisedAmount()"
              [(assignEnabled)]="assignEnabled"
              [(links)]="links"
              [roster]="roster()"
            />
          </div>
        </app-content-container>
      </div>

      <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
        <button type="button" class="rounded-md border border-primary-border px-4 py-2 text-sm font-semibold" (click)="cancel()" [disabled]="submitting()">
          {{ t('cancel') }}
        </button>
        <button type="submit" class="btn btn-primary btn-no-grow disabled:opacity-50" [disabled]="submitting() || !assignmentValid()">
          {{ t('save') }}
        </button>
      </div>
    </form>
  </app-panel-body>
</ng-container>
